import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import { Small } from 'foundations-components/transitional/components/Small';
import { Table } from 'foundations-components/transitional/components/Table';
import { Avatar } from 'avatar-components';
import ApprovalStepStatusText from '../sidebar/ApprovalStepStatusText';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const approversWithStatus = props => {
  const {
    approversWithStepStatuses
  } = props;
  return /*#__PURE__*/_jsxs(Table, {
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsxs("th", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.approvers"
          }), " (", approversWithStepStatuses.length, ")"]
        })
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: approversWithStepStatuses.map(([approver, status]) => /*#__PURE__*/_jsx("tr", {
        "data-test-id": "approval-edit-review-row",
        children: /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsxs(TFlex, {
            alignItems: "center",
            justify: "between",
            children: [/*#__PURE__*/_jsxs(TFlex, {
              alignItems: "center",
              children: [/*#__PURE__*/_jsx(Avatar, {
                hubSpotUserEmail: approver.email,
                marginInlineEnd: "400"
              }), /*#__PURE__*/_jsxs(TFlex, {
                direction: "column",
                children: [/*#__PURE__*/_jsx(FormattedName, {
                  givenName: approver.firstName,
                  familyName: approver.lastName
                }), /*#__PURE__*/_jsx(Small, {
                  use: "help",
                  children: approver.email
                })]
              })]
            }), /*#__PURE__*/_jsx(ApprovalStepStatusText, {
              approvalStepStatus: status
            })]
          })
        })
      }, approver.ownerId))
    })]
  });
};
export default approversWithStatus;